import { defineComponent as _defineComponent } from 'vue'
import { PaymentAggregateLimit } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AggregatedLimitErrorMessage',
  props: {
  aggregatedLimitForCurrency: {
    type: Object as PropType<PaymentAggregateLimit>,
    required: true,
  },
},
  setup(__props) {



return { __sfc: true,formatCurrencyValue }
}

})